import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateSampling, UpdateSamplingPayload } from '../api/updateSampling';

export const useUpdateSampling = (productId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, body }: UpdateSamplingPayload) => {
      return await updateSampling(productId, { id, body });
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['product', productId] }),
        queryClient.invalidateQueries({ queryKey: ['products-all'] })
      ]);
    }
  });
};
